import { UserPreferencesNegativeNumberFormatEnum } from "components/modal/settings/negative-number-formats";
import { Region } from "./regions";
import { AllocationKey, CommitmentCalculation } from "api/ux/src";
import { UserPreferencesDateFormatEnum } from "components/modal/settings/date-formats";
import { UserPreferencesUnitOfAreaEnum } from "components/modal/settings/unitOfArea";
export const userPreferencesDefaults = { allocationKey: AllocationKey.Nav,
    commitmentCalculation: CommitmentCalculation.RecomputedCommitment,
    dateFormat: UserPreferencesDateFormatEnum.Localized,
    enableJSONEditing: false,
    negativeNumberFormat: UserPreferencesNegativeNumberFormatEnum.MinusPrefixed,
    region: Region.enUS,
    unitOfArea: UserPreferencesUnitOfAreaEnum.SquareMeter };
